import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IOpenedPhones } from 'shared/types/openedPhones';

const initialState = {
  openedPhones: {} as IOpenedPhones,
};

/* istanbul ignore next */
const phonesSlice = createSlice({
  initialState,
  name: 'phones',
  reducers: {
    setOpenedPhones: (state, action: PayloadAction<IOpenedPhones>) => {
      state.openedPhones = action.payload;
    },
  },
});

export const {
  reducer: phonesReducer,
  actions: { setOpenedPhones },
} = phonesSlice;
